module.exports = __webpack_public_path__ + "static/news-nus-6d67da3ccb62ed1b6f5f420da885681b.png";